import { Language } from 'models/interfaces/languages/Language';

export default class Languages {
  static readonly NL: Language = { locale: 'nl', name: 'NL' };

  static readonly EN: Language = { locale: 'en', name: 'EN' };

  static readonly AR: Language = { locale: 'ar', name: 'AR' };
}
